import { Skeleton } from '@accure/ui';

import type { SitePreview } from '@/api/fe-api/domain/entities/site';
import type { Activity } from '@/modules/documents/domain/entities/activity';
import { label } from '@/utils/format/label';

import { WhatsNewLink } from '../whats-new-link';

type ActivityGroupedNewsProps = {
  site: SitePreview | undefined;
  activities: Activity[];
  isLoading?: boolean;
};

export function ActivityGroupedNews({
  site,
  activities,
  isLoading,
}: ActivityGroupedNewsProps) {
  if (isLoading) {
    return <Skeleton className="h-6 w-full" />;
  }

  if (!site) {
    return null;
  }

  const path =
    activities.length === 1
      ? `/asset/${site.id}/documents?id=${encodeURIComponent(activities[0]?.document.id) || ''}`
      : `/asset/${site.id}/documents?type=Reports&sort=last_uploaded&order=desc`;

  return (
    <WhatsNewLink
      to={path}
      title={activities.map((activity) => activity.document.name).join('\n')}
    >
      {site.name}: {activities.length} new{' '}
      {label(['report', 'reports'], activities.length)}
    </WhatsNewLink>
  );
}
